export default {
  STATE_ERROR: 'error' as const,
  STATE_WAITING: 'waiting' as const,
  STATE_PREPROCESSING: 'preprocessing' as const,
  STATE_UPLOADING: 'uploading' as const,
  STATE_POSTPROCESSING: 'postprocessing' as const,
  STATE_COMPLETE: 'complete' as const,
}
